<div class="download">
    <a #fileLink
       [type]="contentType"
    ></a>
</div>
